"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = void 0;
var defaultTranslations = {
  birthDateError: "You must be over the age of 18 to play",
  mobilesDontMatch: "Mobile numbers do not match",
  changePhoneValidation: "Phone can only contain numbers and '+' sign",
  changePinValidation: "Pin can only contain numbers",
  changePinDontMatch: "Pin codes do not match",
  confirmPhoneCodeSent: "Code has been sent",
  signUpError: "Error signing up",
  firstName: "Legal first name",
  firstNameMessage: "This should be exactly as it appears on your ID documents",
  lastName: "Last name",
  email: "Email",
  emailConfirm: "Confirm email",
  incorrectEmail: "Please enter a valid email address",
  existsEmail: "Email already registered",
  unmatchEmail: "Emails don't match",
  existsUserName: "Username already taken",
  postcode: "Postcode",
  postcodeIncorrect: "Postcode must be between 5 and 7 characters",
  postcodeDoesntExist: "Postcode does not exist.",
  street1: "Street",
  city: "City",
  password: "Password",
  unmatchPasswords: "Passwords don't match",
  incorrectPasswords: "At least 8 characters and contain 1 uppercase character, 1 lowercase character and 1 number",
  edit: "Edit Details",
  birthDate: "Date of birth",
  mobileNumber: "Mobile number",
  confirm: "Confirm",
  minLengthError: "must be at least",
  maxLengthError: "must be at most",
  characters: "characters",
  pin: "Pin",
  mustAgreeTerms: "Terms & Conditions must be accepted",
  mustAgreePrivacy: "You must have read and agree to our Privacy Policy",
  username: "Username",
  step: "Step",
  messagePersonalDetails: "First some personal details",
  next: "Next",
  back: "Back",
  messageContactDetails: "A few contact details",
  signUpMobileWarning: "Please enter your mobile number without a leading zero and your countries international dialing code. For example",
  messageSecurityDetails: "Now your security details",
  messageConsent: "Where you have given consent to receive marketing from Low6 or our associates, we may use your personal details to identify products and services which may be of interest to you. You can update your preferences at any time from your account settings.",
  termsConditions: "Terms & Conditions",
  confirmTermsConditions: "Please confirm that you have read and agreed to our Terms & Conditions",
  privacyCookies: "Privacy & Cookies",
  confirmPrivacyPolicy: "Please confirm that you have read and agreed to our privacy policy",
  confirmMarketing: "Opting in to marketing will allow us to notify you of exclusive offers, promotions and bonuses.",
  confirmAgreeAll: "By selecting all you agree to the above terms and conditions, Privacy notice and confirm consent for the above marketing mediums.",
  messageTermsPrivacy: "You must agree that you have read terms & conditions and privacy policy to continue.",
  finish: "Finish"
};
exports.defaultTranslations = defaultTranslations;